import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { randomTranslation } from '../image_utilities/Translate';
import { imageShape } from '../shapes/ImageShapes';
import NumberField from './UI/NumberField';

class Intensify extends React.Component {
  state = {
    numOutputFrames: 3,
    intensity: 10,
    delay: 40,
    inputIsValid: {
      numFrames: true,
      intensity: true,
      delay: true,
    },
  };

  handleIntensifyClick = () => {
    this.props.onImageChangeStart();
    const promises = this.props.images.map(
      image =>
        new Promise(resolve => {
          randomTranslation(
            image.frames,
            this.state.intensity,
            this.state.delay,
            this.shouldShowOutputFramesInput() ? this.state.numOutputFrames : null
          ).then(frames => {
            resolve({
              ...image,
              frames,
            });
          });
        })
    );
    Promise.all(promises).then(modifiedImages => {
      this.props.onImageChange(modifiedImages);
    });
  };

  shouldShowOutputFramesInput = () => {
    return this.props.images.some(image => image.frames.length === 1);
  };

  handleNumOutputFramesChange = (numOutputFrames, isValid) => {
    this.setState(prevState => ({
      numOutputFrames,
      inputIsValid: { ...prevState.inputIsValid, numOutputFrames: isValid },
    }));
  };

  handleIntensityChange = (intensity, isValid) => {
    this.setState(prevState => ({
      intensity,
      inputIsValid: { ...prevState.inputIsValid, intensity: isValid },
    }));
  };

  handleDelayChange = (delay, isValid) => {
    this.setState(prevState => ({
      delay,
      inputIsValid: { ...prevState.inputIsValid, delay: isValid },
    }));
  };

  canSubmit = () => Object.values(this.state.inputIsValid).every(Boolean);

  render() {
    return this.props.images.length ? (
      <Stack useFlexGap sx={{ width: '100%' }} spacing={1} justifyContent="flex-end" alignItems="flex-start">
        <Box sx={{ maxWidth: '100%' }}>
          <Stack useFlexGap sx={{ width: '100%' }} alignItems="flex-start">
            {this.shouldShowOutputFramesInput() && (
              <Box sx={{ maxWidth: '100%' }}>
                <NumberField
                  label="Number of Output Frames"
                  onChange={this.handleNumOutputFramesChange}
                  value={this.state.numOutputFrames}
                  allowPositive
                />
              </Box>
            )}
            <Box sx={{ maxWidth: '100%' }}>
              <NumberField
                label="Intensity"
                onChange={this.handleIntensityChange}
                value={this.state.intensity}
                allowPositive
              />
            </Box>
            <Box sx={{ maxWidth: '100%' }}>
              <NumberField
                label="Wait Between Frames"
                suffix="ms"
                onChange={this.handleDelayChange}
                value={this.state.delay}
                allowPositive
                allowZero
              />
            </Box>
          </Stack>
        </Box>
        <Box sx={{ maxWidth: '100%' }}>
          <Button
            className="glint-tactile"
            variant="contained"
            color="primary"
            onClick={this.handleIntensifyClick}
            disabled={!this.canSubmit()}
          >
            Intensify
          </Button>
        </Box>
      </Stack>
    ) : (
      <Typography>Here you make an image shake, but first you need to add one!</Typography>
    );
  }
}

Intensify.propTypes = {
  images: PropTypes.arrayOf(imageShape),
  onImageChange: PropTypes.func.isRequired,
  onImageChangeStart: PropTypes.func,
};
Intensify.defaultProps = {
  images: [],
  onImageChange() {},
  onImageChangeStart() {},
};

export default Intensify;
